import { Cell, Image, Workbook, Worksheet } from "exceljs";
import { saveAs } from "file-saver";

const type =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

type IGetRowOutput = string | undefined;
type ICell = { text: string; from: number; options?: Partial<Cell> };

export abstract class ExcelJSBase {
  public workbook: Workbook;
  constructor() {
    this.workbook = new Workbook();
  }
  abstract create(data: unknown): Workbook;

  download(fileName: string = "excel file name") {
    this.workbook.xlsx.writeBuffer().then((data) => {
      const blob = new Blob([data], { type });
      saveAs(blob, fileName);
    });
  }
  addWorksheet(name: string) {
    return this.workbook.addWorksheet(name);
  }
  addImage(img: Image) {
    return this.workbook.addImage(img);
  }

  addRow(worksheet: Worksheet, cells: Array<ICell>) {
    const rowValues = cells.reduce((output: IGetRowOutput[], current) => {
      const diff = current.from - output.length + 1;
      if (diff > 0) output.push(...Array(diff).fill(undefined));
      output[current.from] = current.text;
      return output;
    }, []);
    const row = worksheet.addRow(rowValues);
    for (const cell of cells) {
      if (cell.options) {
        for (const [key, value] of Object.entries(cell.options)) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (row.getCell(cell.from + 1) as any)[key] = value;
        }
      }
    }
  }
}
